module.exports = __webpack_public_path__ + "design-tools.1bn6JH9V.svg";